import React from 'react';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import type { TextProps } from 'Components/frameworks/text/Text';
import { Text } from 'Components/frameworks/text/Text';
type Props = TextProps & {
  id?: string;
};
export const TextLine = ({ id, ...props }: Props) => (
  <SiteContainer className="Line" id={id}>
    <Text {...props} />
  </SiteContainer>
);
